/** Date calendaire au format français (jj/mm/aaaa) ; `fallback` quand la valeur est absente. */
export const formatDateFr = (value?: Date | string | null, fallback = ''): string =>
  value ? new Date(value).toLocaleDateString('fr-FR') : fallback;
